import classNames from "classnames/bind";
import styles from "./Version.module.css";
import { QRCodeSVG } from "qrcode.react";
import { useTranslation } from "react-i18next";

const cx = classNames.bind(styles);

function Version() {
    const { t } = useTranslation();

    return (
        <div className={cx('version-wrapper')}>
            <div className={cx('version-device')}>
                <p className={cx('label')}>{t("version.mobileVersion")}</p>
                <div className={cx('code')}>
                    <div className={cx('code-item')}>
                        <QRCodeSVG
                            value={"https://play.google.com/store/apps/details?id=com.camera_app&pcampaignid=web_share"}
                            size={128}
                            bgColor={"#ffffff"}
                            fgColor={"#000000"}
                            level={"L"}
                            includeMargin={false}
                        />
                        <p className={cx('device')}>Android app</p>
                    </div>
                    <div className={cx('code-item')}>
                        <QRCodeSVG
                            value={"https://apps.apple.com/vn/app/cameraai-app/id6449644794?l=vi"}
                            size={128}
                            bgColor={"#ffffff"}
                            fgColor={"#000000"}
                            level={"L"}
                            includeMargin={false}
                        />
                        <p className={cx('device')}>IOS app</p>
                    </div>
                </div>
            </div>
            <div className={cx('version-device')}>
                <p className={cx('label')}>{t("version.desktopVersion")} </p>
                <a className={cx('link')} href={`https://vinorsoft.com/desktop/VNSCamAI.exe`} download>{t("version.downloadDesktopVersion")}</a>
            </div>
        </div>
    )
}

export default Version;